import { render, staticRenderFns } from "./TratamentoDados.vue?vue&type=template&id=209f6ea9&"
import script from "./TratamentoDados.vue?vue&type=script&lang=js&"
export * from "./TratamentoDados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports